import {Component, Inject, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {LeftpanelComponent} from '../../../leftpanel/leftpanel.component';
import {ConfService} from '../../../conf.service';
import {Router} from '@angular/router';
import {ConnecttocrudService} from '../../../connecttocrud.service';
import {KongService} from '../../../kong.service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-add-user-group-environment-component',
  templateUrl: './add-user-group-environment-component.component.html',
  styleUrls: ['./add-user-group-environment-component.component.scss']
})
export class AddUserGroupEnvironmentComponentComponent implements OnInit {

  selectedEnvironmentList: any;
  environmentList: string[];
  selectedUserlist: any;
  usersList = [];

  constructor(
      private dialog: MatDialog,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public platform: LeftpanelComponent,
      public dialogRef: MatDialogRef<AddUserGroupEnvironmentComponentComponent>,
      public confPost: ConfService,
      public router: Router,
      public _service: ConnecttocrudService,
      public kongService: KongService) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    if (this.data['environmentList']) {
      this.environmentList = this.data['environmentList'];
    }
    if (this.data['userList']) {
      this.usersList = this.data['userList'];
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  addEnvironment() {
    if (this.selectedUserlist.length > 0 && this.selectedEnvironmentList.length > 0) {
      this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'usergroups', 'id=' + this.data['id']).subscribe(async result => {
        if (result) {
          const shortName = localStorage.getItem('partner').split('-');
          const userGroupResponse = result[0];

          for (let e of this.selectedEnvironmentList) {
            const roleDetails = {
              'role': e + '=>' + e + '=>' + this.data['groupName'],
              'permission_groups': [],
              'permissions': [],
              'roles': [],
              'exclusions': [],
              'partner': e,
              'account': e,
              'type': 'account'
            };
            const roleId = await this.createRoleForEachEnvironment(roleDetails);

            userGroupResponse['environments'].push(
                {
                  name: e,
                  account: e,
                  users: this.selectedUserlist.map(user => user['id']),
                  roles: [roleId],
                  exclusions: {
                    permissions: [],
                    permission_groups: [],
                    role: []
                  },
                  audit_logs: [
                    {
                      action: 'CREATE',
                      by: shortName[shortName.length - 1],
                      at: Date.now()
                    }
                  ]
                }
            );
          }

          this._service.patchItemUpdate(this.data['id'], {environments: userGroupResponse['environments']}, 'v1', environment.accessPartner, environment.accessPartner, 'usergroups').subscribe(res => {
            if (res) {
              for (const user_id of this.selectedUserlist.map(user => user['id'])) {
                this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'id=' + user_id).subscribe(resp => {
                  if (resp) {
                    const user = resp;
                    if (!user[0]['user_groups'].includes(this.data['id'])) {
                      user[0]['user_groups'].push(this.data['id']);
                      this._service.patchItemUpdate(user[0]['id'], {'user_groups': user[0]['user_groups']}, 'v1', environment.accessPartner, environment.accessPartner, 'users').subscribe(updateRes => {
                        this.platform.openSnackBar('User Group created', 'Success', {
                          duration: 2000,
                          verticalPosition: 'top',
                          horizontalPosition: 'center'
                        });
                        this.dialogRef.close('success');
                      });
                    }

                  }
                });
              }
              this.dialogRef.close('success');
            }
          });
        }
      });
    } else {
      this.platform.openSnackBar(' Please make sure that your password follows our password policy ', 'Error', {
        duration: 2000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  removeEnvironment(element: any) {
    const index = this.selectedEnvironmentList.indexOf(element);
    if (index >= 0) {
      this.selectedEnvironmentList.splice(index, 1);
    }
  }

  removeUser(element: any) {
    const index = this.selectedUserlist.indexOf(element);
    if (index >= 0) {
      this.selectedUserlist.splice(index, 1);
    }
  }

  createRoleForEachEnvironment(roleDetail) {
    return new Promise((resolve, reject) => {
      this._service.addItem(roleDetail, 'v1', environment.accessPartner, environment.accessPartner, 'roles').subscribe(data => {
        if (data) {
          resolve(data['upsertedId']);
        } else {
          resolve('failed');
        }
      }, error => {
        resolve('failed');
      });
    });
  }

}
